const en = {
  // Navbar
  nav_why: 'Why',
  nav_system: 'System',
  nav_partnership: 'Partnership',
  nav_esg: 'ESG',
  nav_resources: 'Resources',
  nav_contact: 'Contact',

  // Hero
  hero_title: 'Industrializing\nCharcoal Grilling',
  hero_description: 'Bringing authentic charcoal flavor to industrial-scale food production!\n\n\u00a0 ① Vertical charcoal grilling structure\n\u00a0 \u00a0 \u00a0 \u00a0 \u00a0 \u00a0 \u00a0 ② Daily output of 10,000 packs (fish-based)\n\u00a0 \u00a0 ③ Refrigerated shelf life of 5.5months',

  // Problem
  problem_hero_title: 'Why Has Charcoal Grilling Never Been Industrialized?',
  problem_hero_sub: 'Charcoal grilling is the world\'s most beloved cooking method. \n\u00a0Yet, scaling it has always seemed impossible.',
  problem_col1_title: '1. Problem',
  problem_col1_summary: 'Traditional charcoal grilling has always depended on manual skill and small-batch cooking.',
  problem_col1_detail: 'Fat drips onto hot charcoal during grilling has led to release of smoke and harmful compounds.\u00a0\n\nThis fundamental structural flaw has kept charcoal grilling confined to manual methods for generations, preventing it from evolving into any standardized, mass-production system.\n\nAs a result, most food manufacturers have relied on steam cooking rather than charcoal.',
  problem_col2_title: '2. Solution',
  problem_col2_summary: 'K-Grill183 has completely reinvented the architecture of charcoal grilling.',
  problem_col2_detail: 'With positioning of charcoal on both sides and grilling ingredients vertically, fat no longer drips onto the charcoal at all.\n\nThis design eliminates any release of harmful compounds and ensures zero smoke.\n\nThe result: Charcoal heat is distributed evenly enabling consistent, high-quality grilling at any scale.',
  problem_col3_title: '3. Impact',
  problem_col3_summary: 'Charcoal Grilling\nIs Now\nan Industry.',
  problem_col3_list: 'Consistent charcoal-grilled flavor\nPrevention of harmful compound generation\nZero smoke emission\nFully automated cooking system',
  problem_col3_production_label: 'Daily Production Capacity:',
  problem_col3_production: 'Fish: 10,000 packs/day\nPork: 12,000 packs (250g each)\nChicken: 5,000 birds/day',
  problem_col3_closing: 'Charcoal grilling is no longer\njust a restaurant technique —\nit\'s now an industrial food production system.',

  // Innovation
  innovation_hero_title: 'A High-Output Charcoal Grilling System',
  innovation_hero_sub: 'Our automated Charcoal Griller® consistently makes high-quality,\nmass-produced charcoal-grilled food a commercial reality',
  innovation_table_title: 'How Charcoal Grilling Production Has Changed',
  innovation_col1: 'Category',
  innovation_col2: 'Traditional',
  innovation_col3: 'K-Grill 183',
  innovation_c0_criteria: 'Production Method',
  innovation_c0_label: 'Manual, labor-intensive cooking',
  innovation_c0_value: 'Fully automated charcoal-grill system',
  innovation_c1_criteria: 'Production Scale',
  innovation_c1_label: 'Small-batch only',
  innovation_c1_value: 'Automated mass production',
  innovation_c2_criteria: 'Productivity',
  innovation_c2_label: 'Dependent on worker skill',
  innovation_c2_value: '10,000 packs/day (for fish)',
  innovation_c3_criteria: 'Distribution',
  innovation_c3_label: 'Immediate consumption only',
  innovation_c3_value: 'Refrigerated shelf life of 5.5 months → HMR & export-ready',
  innovation_c4_criteria: 'Food Safety',
  innovation_c4_label: 'Harmful compounds caused by fat drips',
  innovation_c4_value: 'Zero fat drip — harmful compounds eliminated',
  innovation_c5_criteria: 'Business Model',
  innovation_c5_label: 'Consumed only at restaurants',
  innovation_c5_value: 'Food manufacturing & global distribution',
  innovation_c6_criteria: 'Market Scalability',
  innovation_c6_label: 'Limited to store expansion',
  innovation_c6_value: 'Mass supply markets (HMR · Catering · Halal)',
  innovation_video1: 'K-Grill183 Charcoal Grill — Overview',
  innovation_video2: 'K-Grill183 Automated Grill — System Demo',

  // Market
  market_hero_title: 'Opening New Food Markets',
  market_hero_sub: 'A breakthrough production system for charcoal-grilled HMR\nNow seeking strategic partners to scale into the global food industry',
  market_target0: 'Food companies developing\ncharcoal-grilled HMR products',
  market_target1: 'Suppliers of grilled fish\nfor institutional catering',
  market_target2: 'Grilled food franchises\n(fish, pork & chicken)',
  market_target3: 'K-Food (Halal) exporters',

  // ESG
  esg_tagline: 'K-Grill183 is',
  esg_title: 'A cooking technology\nbuilt for health and the environment',
  esg_cat0: 'Environment',
  esg_item0_0: 'Reduced harmful compounds',
  esg_item0_1: 'Zero smoke',
  esg_item0_2: 'Reduced food waste',
  esg_cat1: 'Social',
  esg_item1_0: 'Advancing public health',
  esg_item1_1: 'Upgraded institutional meal quality',
  esg_cat2: 'Governance',
  esg_item2_0: 'Standardized food production',

  // Reference
  ref_title: 'Resources',
  ref_sub: 'The technology and track record behind K-Grill183',
  ref_card0_title: 'Patented Technologies',
  ref_card0_desc: 'Automated charcoal grill technology patent',
  ref_card1_title: 'Technical Materials',
  ref_card1_desc: 'K-Grill183 product demo videos',
  ref_card2_title: 'Certifications',
  ref_card2_desc: 'Food safety certifications',
  ref_card3_title: 'Research Reports',
  ref_card3_desc: 'PAH reduction effectiveness studies',
  ref_video_title: 'Product Videos',
  ref_video0: 'Mackerel — Charcoal Grilled',
  ref_video1: 'Pork Belly 513g (3.5cm thick) — Charcoal Grilled',
  ref_video2: 'Pork Belly 227g (1.5cm thick) — Charcoal Grilled',
  ref_patent_title: 'Patents & Official Documents',
  ref_cert_title: 'Certified 5.5-month Refrigerated Shelf Life',
  ref_articles_title: 'Research Papers & Press Coverage',
  ref_article0_title: 'Koreans love the \'fire flavor\' — but is charcoal-grilled meat raising cancer risk?',
  ref_article1_title: 'In high-heat direct-fire grilling, smoke from dripping fat is the primary driver of PAH formation. Fat and smoke removal treatments can reduce total PAH (4 types) by up to 89%.',
  ref_article2_title: 'Vertical gas BBQ produces low PAH levels, while horizontal lava-rock BBQ showed PAH values up to 30 μg/kg — including carcinogenic benzo[a]pyrene — depending on food type and cook time.',

  // Contact
  contact_title: 'Get in Touch',
  contact_sub: 'Interested in learning more about K-Grill183?\nWe\'d love to hear from you.',
  contact_name: 'Name',
  contact_company: 'Company',
  contact_email: 'Email',
  contact_phone: 'Phone',
  contact_message: 'Message',
  contact_submit: 'Send Message',
  contact_submitting: 'Sending...',
  contact_success: 'Your message has been sent successfully. We\'ll be in touch soon.',
  contact_error: 'Something went wrong. Please try again.',

  // Footer
  footer_tagline: 'Building the future of food\nthrough vertical charcoal grilling technology.',
  footer_contact: 'Contact',
  footer_links: 'Quick Links',
  footer_link_problem: 'Why',
  footer_link_innovation: 'System',
  footer_link_market: 'Partnership',
  footer_link_esg: 'ESG',
  footer_link_contact: 'Contact',
  footer_copyright: '© 2024 K-Grill183. All rights reserved.',
};

export default en;
